/**
 * This component is Header for application.
 * It will responsible for Enterprise Management and Manage Users link
 */
import React from 'react';
import { useSelector } from 'react-redux';
import Menu from 'spark-ui/Menu/Menu';
import MenuButton from 'spark-ui/Menu/MenuButton';
import MenuNavItem from 'spark-ui/Menu/MenuNavItem';
import Permission from 'spark-util/Permission';
import { paths, navigation } from 'spark-views/enterprise/enterpriseRoutes';
import { paths as reportPaths } from 'spark-views/configuration/reportType/reportRoutes';
import { userCurrentEnterprise } from 'spark-state/common/user/userReducer';
import { paths as bulkDownloadPaths } from 'spark-views/bulkDownload/downloadRoutes';
import { paths as auditReportPaths } from 'spark-views/safetyLetter/admin/report/auditReportRoutes';
import { paths as overdueAckPath } from 'spark-views/safetyLetter/admin/overdueAck/OverdueAckRoutes';
import { paths as manageRolesPath } from 'spark-views/safetyLetter/admin/manageRoles/manageRolesRoutes';
import { ArrowDropDown } from '@material-ui/icons';

const ManageUsers = (props) => {
	//TODO: Once enterpriseId is in redux store,
	//use a selector here to get the enterpriseId instead of hardcoding
	const enterpriseId = useSelector(userCurrentEnterprise);
	const to = navigation.enterpriseUsers(enterpriseId);
	return <MenuNavItem to={to} {...props} />;
};

const AdminMenu = () => (
	<Menu renderTarget={TriggerButton}>
		{(toggle) => (
			<React.Fragment>
				<Permission requires="em.manageEnterprises">
					<MenuNavItem to={paths.enterpriseList} onClick={toggle} label="Enterprise Management" />
				</Permission>
				<Permission requires="em.safetyAdmin">
					<ManageUsers onClick={toggle} label="Manage Users" />
				</Permission>
				<Permission requires="sm.manageRoles">
					<MenuNavItem to={manageRolesPath.root} onClick={toggle} label="Manage Roles" />
				</Permission>
				<Permission requires="sm.reportTypeConfigurationModule">
					<MenuNavItem to={reportPaths.reportTypeList} onClick={toggle} label="Report Type Configuration" />
				</Permission>
				<Permission requires="bd.downloadDocuments">
					<MenuNavItem to={bulkDownloadPaths.root} onClick={toggle} label="Bulk Download" />
				</Permission>
				<Permission requires="sm.auditReports">
					<MenuNavItem to={auditReportPaths.root} onClick={toggle} label="Audit Reports" />
				</Permission>
				<Permission requires="sm.overdueAckManagement">
					<MenuNavItem to={overdueAckPath.root} onClick={toggle} label="Acknowledgement Mgmt" />
				</Permission>
			</React.Fragment>
		)}
	</Menu>
);

const TriggerButton = (isOpen, toggle) => (
	<MenuButton label="Admin" open={isOpen} onClick={toggle}>
		&nbsp;
		<ArrowDropDown/>
	</MenuButton>
);

export default AdminMenu;
